export interface Category {
  id: string;
  name: string;
  description: string;
  image_url: string;
  product_count: number;
  slug: string;
}

export const mockCategories: Category[] = [
  {
    id: '1',
    name: 'Filtre Kahve',
    description: 'Pour-over, French Press ve filtre makineleri için özel kavrum',
    image_url: 'https://public.readdy.ai/ai/img_res/34db7d1209350be33fce40c8afa47eb9.jpg',
    product_count: 14,
    slug: 'filtre-kahve',
  },
  {
    id: '2',
    name: 'Espresso',
    description: 'Moka pot, espresso makinesi ve Aeropress için yoğun aromalar',
    image_url: 'https://readdy.ai/api/search-image?query=espresso%20shot%20close%20up%20crema%20professional%20photography%20dark%20moody%20lighting%20specialty%20coffee%20rich%20brown%20tones%20minimal%20elegant&width=600&height=400&seq=cat2&orientation=landscape',
    product_count: 9,
    slug: 'espresso',
  },
  {
    id: '3',
    name: 'Cold Brew',
    description: '12-24 saat soğuk demleme için özel harmanlanmış blendler',
    image_url: 'https://readdy.ai/api/search-image?query=cold%20brew%20coffee%20glass%20ice%20minimal%20elegant%20product%20photography%20dark%20background%20specialty%20coffee%20refreshing%20premium&width=600&height=400&seq=cat3&orientation=landscape',
    product_count: 5,
    slug: 'cold-brew',
  },
  {
    id: '4',
    name: 'Set & Hediye',
    description: 'Sevdiklerinize özel hazırlanmış premium kahve hediye setleri',
    image_url: 'https://readdy.ai/api/search-image?query=luxury%20coffee%20gift%20set%20box%20packaging%20premium%20minimal%20elegant%20product%20photography%20white%20background%20kraft%20paper%20ribbon%20artisan&width=600&height=400&seq=cat4&orientation=landscape',
    product_count: 6,
    slug: 'set-hediye',
  },
];
